export { default } from './ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/ThemeProvider/index.js
// module id = 385
// module chunks = 0